<template>
  <div class="navigation navigation--main">
    <div class="navigation__sub--wrapper">
      <!--LOADED CONTENT START-->
      <header id="header" class="search--closed navigation--sticky">
        <div class="nav--wrapper navigation--closed">
          <a class="logo--wrapper" :href="'https://www.loxone.com/'">
            <img src="https://www.loxone.com/wp-content/uploads/sites/2/2017/12/loxone_logo.png" />
          </a>
          <div class="sidenavigation--wrapper">
          </div>
        </div>
      </header>
      <!--LOADED CONTENT END-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "MainNavigation",
        created() {
          this.page_path = 'enen';
        },
    };
</script>

<style scoped>
header#header {
  background-color: #000000;
  font-size: 0;
  line-height: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 99999999;
}
header#header .nav--wrapper {
  max-width: 1440px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 0 auto;
  vertical-align: top;
  display: flex;
  justify-content: space-between;
}

header#header .nav--wrapper .logo--wrapper {
  display: inline-block;
  vertical-align: top;
  padding-right: 20px;
  width: 110px;
}

header#header .nav--wrapper .logo--wrapper img {
  height: 20px;
  width: 89px;
  max-width: 89px;
  padding: 14px 0;
  box-sizing: content-box;
}
header#header .nav--wrapper .sidenavigation--wrapper {
  padding-left: 20px;
  width: 140px;
  display: inline-block;
  vertical-align: top;
  text-align: right;
}
header#header .nav--wrapper .sidenavigation--wrapper .sidenavigation--entry {
  padding: 14px 0 14px 10px;
  display: inline-block;
}
</style>